import React from 'react';
import { motion } from 'framer-motion';
import BookingButton from './BookingButton';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img src="https://i.postimg.cc/rs3LX6Lq/KIM-15.jpg" alt="Clinic Background" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-white/80 backdrop-blur-[2px]"></div>
      </div>

      <div className="relative z-10 container mx-auto px-4 flex flex-col items-center text-center">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="mb-8"
        >
          <img src="https://i.postimg.cc/KYyrZZLD/logooohilll.png" alt="Hill Ear Care Full Logo" className="h-48 md:h-64 h-auto w-auto object-contain mx-auto drop-shadow-sm" />
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="space-y-6 max-w-3xl"
        >
          <div className="flex flex-wrap justify-center gap-2 md:gap-4 text-sm md:text-base font-medium text-gray-600 uppercase tracking-widest">
            <span className="bg-rose-50 px-3 py-1 rounded-full text-rose-gold-dark border border-rose-100">Professional Ear Wax Removal</span>
            <span className="bg-rose-50 px-3 py-1 rounded-full text-rose-gold-dark border border-rose-100">Dudley & Wolverhampton</span>
          </div>

          <h1 className="text-4xl md:text-6xl font-bold text-gray-900 leading-tight">
            Clear hearing, <span className="text-rose-gold">simple pricing</span>
          </h1>

          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto">
            Experience professional, safe, and effective ear wax removal in our comfortable clinic or the convenience of your own home.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
            <BookingButton text="Book Appointment" className="w-full sm:w-auto text-lg px-8 py-4" />
          </div>

          <div className="mt-8 bg-white/80 border border-rose-100 p-4 rounded-xl max-w-lg mx-auto shadow-sm flex items-start gap-3 text-left">
            <div className="flex-shrink-0 mt-1">
              <SafeIcon icon={FiIcons.FiInfo} className="text-rose-gold text-xl" />
            </div>
            <p className="text-sm text-gray-600">
              <span className="font-semibold text-gray-800">Booking Tip:</span> For the best results, we recommend using medicinal olive oil for 3-5 days prior to your appointment to soften any wax.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;